export const blue = '#2e64e2'
export const darkBlue = '#2a4291'
export const gray70 = '#697179'
